/* eslint-disable no-param-reassign */

const ensureEntities = (state) => {
  if (!state.entities) {
    state.entities = {
      listings: {},
      listingVariants: {},
      assets: {
        listingAssets: {},
        listingVariantAssets: {},
        masterAssets: {},
        masterVariantAssets: {},
      },
    };
  }
};

const ensureAssets = (state) => {
  ensureEntities(state);

  if (!state.entities.assets) {
    state.entities.assets = {
      listingAssets: {},
      listingVariantAssets: {},
      masterAssets: {},
      masterVariantAssets: {},
    };
  }
};

export const upsertListing = (state, listing) => {
  if (!listing?._id) return;

  ensureEntities(state);
  state.entities.listings[listing._id] = listing;
};

export const removeListing = (state, listingProductId) => {
  if (!listingProductId || !state.entities?.listings) return;

  delete state.entities.listings[listingProductId];
};

export const upsertListingVariant = (state, listingVariant) => {
  if (!listingVariant?._id) return;

  ensureEntities(state);
  state.entities.listingVariants[listingVariant._id] = listingVariant;
};

export const removeListingVariant = (state, listingVariantId) => {
  if (!listingVariantId || !state.entities?.listingVariants) return;

  delete state.entities.listingVariants[listingVariantId];
};

export const setListingAssets = (state, listingProductId, assets) => {
  if (!listingProductId) return;

  ensureAssets(state);
  state.entities.assets.listingAssets[listingProductId] = assets;
};

export const setListingVariantAssets = (state, listingVariantId, assets) => {
  if (!listingVariantId) return;

  ensureAssets(state);
  state.entities.assets.listingVariantAssets[listingVariantId] = assets;
};

export const setMasterAssets = (state, masterProductId, assets) => {
  if (!masterProductId) return;

  ensureAssets(state);
  state.entities.assets.masterAssets[masterProductId] = assets;
};

export const setMasterVariantAssets = (state, masterVariantId, assets) => {
  if (!masterVariantId) return;

  ensureAssets(state);
  state.entities.assets.masterVariantAssets[masterVariantId] = assets;
};
